import HttpService from '../http/http.service';
import { PatchViewModel } from '@/types/apiServerContract';

const API_PATH = 'patch/';

export class PatchApi {
    public static async GetPatchData(realmId: number): Promise<PatchViewModel> {
        return HttpService.Get<PatchViewModel>(API_PATH + 'GetPatchData', {
            realmId
        });
    }
}
